import { gql } from "@apollo/client";

export const GET_VM_DAILY_CPU = gql`
  query GetVmDailyCpu($vmId: ID!, $date: String!) {
    getVmDailyCpu(vmId: $vmId, date: $date) {
      vmId
      vmName
      date
      hourlyCpu {
        hour
        cpuMax
      }
    }
  }
`;

export const GET_VM_DAILY_RAM = gql`
  query GetVmDailyRam($vmId: ID!, $date: String!) {
    getVmDailyRam(vmId: $vmId, date: $date) {
      vmId
      vmName
      date
      hourlyRam {
        hour
        ramUsedPercentage
      }
    }
  }
`;

export const GET_VM_DAILY_AVAILABLE_RAM = gql`
  query GetVmDailyAvailableRam($vmId: ID!, $date: String!) {
    getVmDailyAvailableRam(vmId: $vmId, date: $date) {
      vmId
      vmName
      date
      hourlyAvailableRam {
        hour
        availableRamPercentage
      }
    }
  }
`;

export const GET_VM_DAILY_METRICS = gql`
  query GetVmDailyMetrics($vmId: ID!, $date: String!) {
    getVmDailyMetrics(vmId: $vmId, date: $date) {
      vmId
      vmName
      date
      hourlyMetrics {
        hour
        networkIn
        networkOut
        diskRead
        diskWrite
      }
    }
  }
`;